import React from 'react'
import { BaseButton, BaseCard, BaseSwitch } from '@verifier-user/verifier-headless-ui'
import { ChevronDoubleRightIcon } from '@heroicons/react/24/solid'
import { useApplicationContext } from '../../contexts/appContext'

export const BusinessPurpose = ({
  userConsented,
  setUserConsented,
  email,
  handleChangeEmail,
  validateEmail,
  sendCode,
  errorMessage
}) => {
  const { vendorData } = useApplicationContext()

  return (
    <>
      <h3 className={'text-2xl my-0 leading-normal'} data-testid={'business-purpose-title'}>
        Confirm your business purpose{' '}
      </h3>
      <p data-testid='business-purpose-description'>
        <span className='text-base sm:text-lg'>
          Before we start, we need to confirm you’re using Energy View for a business purpose. This service isn’t
          available for personal use. Are you consenting to use this service in a business capacity?
        </span>
      </p>
      <BaseSwitch
        id='authorised-to-consent'
        data-testid='authorised-to-consent'
        className='verifier-switch-left font-medium mb-4'
        checked={userConsented}
        onChange={() => setUserConsented(!userConsented)}
        label={`Yes I am`}
      />

      {userConsented && (
        <>
          <p data-testid='business-purpose-email-description'>
            <span className='text-base sm:text-lg'>
              To get started, we need your email so that you will be able to access your consent dashboard. We may share
              your email address with {vendorData.config.name}.
            </span>
          </p>

          <p data-testid='email-description'>
            <span className='text-base sm:text-lg'>
              Please enter your email. We'll send you a secure code you can use to login.
            </span>
          </p>

          <form onSubmit={sendCode}>
            <BaseCard>
              <label className='block w-2/3 sm:w-1/2'>
                <strong>Email Address:</strong>
                <input
                  id='email'
                  type='email'
                  value={email}
                  onChange={handleChangeEmail}
                  onBlur={validateEmail}
                  className='verifier-input'
                />
              </label>

              {errorMessage && (
                <div className='verifier-error-text text-red-600 mt-2 mb-0' data-testid='login-error'>
                  <ul>
                    {errorMessage.map((msg, index) => (
                      <li key={index}>{msg}</li>
                    ))}
                  </ul>
                </div>
              )}
            </BaseCard>

            <BaseButton
              onClick={sendCode}
              className='mt-4 sm:mt-4'
              data-testid='send-code-button'
              id='send-code-button'
            >
              <span className='text-lg'>Send me a code</span>
              <ChevronDoubleRightIcon className='w-4 h-4 inline' />
            </BaseButton>
          </form>
        </>
      )}
    </>
  )
}
